import { render, staticRenderFns } from "./advertisement-tag.vue?vue&type=template&id=2fba376b&"
import script from "./advertisement-tag.vue?vue&type=script&lang=js&"
export * from "./advertisement-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports